/**
 * Wraps all Group views in a wrapping container. If you want to give all
 * Group views a sidebar for example, you would set that here.
 * 
 * Accepts a "title" prop and passes it down to be set the DefaultLayout.
 * This allows us to easily update the browser tab title on each view.
 */

// import primary libraries
import React from 'react'
import PropTypes from 'prop-types'

// import global components
import DefaultLayout from '../../../global/components/layouts/DefaultLayout.jsx'

const GroupLayout = ({
  children
  , className
  , title
}) => {
  return (
    <DefaultLayout title={title || "Groups"} className={className}>
      {children}
    </DefaultLayout>
  )
}

GroupLayout.Skeleton = DefaultLayout.Skeleton;

GroupLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node)
    , PropTypes.node
  ]).isRequired
  , className: PropTypes.string
  , title: PropTypes.string
}

export default GroupLayout
